import {
  Box,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Paper
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import type { RegraTabelaPreco } from '../hooks/usePoliticasGlobais';

interface Props {
  regras: RegraTabelaPreco[];
  tabelas: { codigo: number; descricao: string }[];
  onChange: (regras: RegraTabelaPreco[]) => void;
}

// AIDEV-NOTE: Regras de auto-selecao de tabela de preco por quantidade total de unidades
export function TabelaPrecoForm({ regras, tabelas, onChange }: Props) {
  const addRegra = () => {
    onChange([
      ...regras,
      { tabela_preco_id: 0, quantidade_minima: 0, quantidade_maxima: null, ordem: regras.length }
    ]);
  };

  const removeRegra = (idx: number) => {
    onChange(regras.filter((_, i) => i !== idx).map((r, i) => ({ ...r, ordem: i })));
  };

  const updateRegra = (idx: number, field: keyof RegraTabelaPreco, value: any) => {
    const next = regras.map((r, i) => (i === idx ? { ...r, [field]: value } : r));
    onChange(next);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle2">Regras de Tabela por Quantidade</Typography>
        <Button size="small" startIcon={<AddIcon />} onClick={addRegra}>
          Adicionar Regra
        </Button>
      </Box>
      {regras.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          Nenhuma regra configurada -- tabela nao muda automaticamente.
        </Typography>
      )}
      {regras.map((regra, idx) => (
        <Paper
          key={idx}
          variant="outlined"
          sx={{ p: 1.5, mb: 1, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}
        >
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Tabela de Preco</InputLabel>
            <Select
              value={regra.tabela_preco_id || ''}
              label="Tabela de Preco"
              onChange={(e) => updateRegra(idx, 'tabela_preco_id', Number(e.target.value))}
            >
              {tabelas.map((t) => (
                <MenuItem key={t.codigo} value={t.codigo}>
                  {t.descricao}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Qtd Minima"
            type="number"
            size="small"
            sx={{ width: 100 }}
            value={regra.quantidade_minima}
            onChange={(e) => updateRegra(idx, 'quantidade_minima', Number(e.target.value))}
            inputProps={{ min: 0 }}
          />
          <TextField
            label="Qtd Maxima"
            type="number"
            size="small"
            sx={{ width: 100 }}
            value={regra.quantidade_maxima ?? ''}
            onChange={(e) =>
              updateRegra(
                idx,
                'quantidade_maxima',
                e.target.value === '' ? null : Number(e.target.value)
              )
            }
            placeholder="Sem limite"
          />
          <IconButton color="error" size="small" onClick={() => removeRegra(idx)}>
            <DeleteIcon />
          </IconButton>
        </Paper>
      ))}
    </Box>
  );
}
